/* eslint-disable import/prefer-default-export */
import React from 'react'
import s from './Hero.module.css'

export function Hero() {
  return (
    <div className={s.root}>
      <div className={s.overlay} />
      <div className={s.content}>
        <div className={s.contentSubtitle}>how it works</div>
        <div className={s.contentTitle}>Renting made easy</div>

        <div className={s.contentDesc}>Finding an apartment should be as easy as ordering a burrito.</div>

        <a className={s.searchApartments} href="/rentals" target="_blank">
          Search Apartments
        </a>
      </div>
    </div>
  )
}
